<template>
  <div>
    <Breadcrumbs
      :paths="[$route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.profile.title") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="pa-5 mt-1" v-if="user">
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <td>
                {{ $t("message.common.idp") }}
              </td>
              <td>
                {{ user.idp }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.profile.login_name") }}
              </td>
              <td>
                {{ user.user }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.common.organization") }}
              </td>
              <td>
                {{ user.organization }}&nbsp;({{ user.nid }})
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.common.group") }}
              </td>
              <td>
                {{ user.group }}&nbsp;({{ user.gid }})
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.common.user") }}
              </td>
              <td>
                <IdName
                  mode="user"
                  type="user"
                  :ids="[user.uid]"
                  :nav_path="nav_path"
                ></IdName>
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.common.role") }}
              </td>
              <td>
                {{ $t("message.common.role_" + user.role) }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("message.profile.source_ip") }}
              </td>
              <td>
                {{ user.source_ip }}
              </td>
            </tr>
            <template v-if="user.allowed_domains.length > 1">
              <tr>
                <td>
                  {{ $t("message.common.any_allow") }}{{ $t("message.common.domain") }}
                </td>
                <td>
                  <v-list>
                    <v-list-item v-for="domain in user.allowed_domains" :key="domain" class="pl-0" dense>
                      {{ $t('message.common.domain_' + domain) }}
                    </v-list-item>
                  </v-list>
                </td>
              </tr>
            </template>
            <template v-if="user.allowed_purposes.length > 1">
              <tr>
                <td>
                  {{ $t("message.common.any_allow") }}{{ $t("message.common.purpose") }}
                </td>
                <td>
                  <v-list>
                    <v-list-item v-for="purpose in user.allowed_purposes" :key="purpose" class="pl-0" dense>
                      {{ $t('message.common.purpose_' + purpose) }}
                    </v-list-item>
                  </v-list>
                </td>
              </tr>
            </template>
            <template v-if="Array.isArray(user.allowed_options) && user.allowed_options.length > 0">
              <tr>
                <td>
                  {{ $t("message.common.any_allow") }}{{ $t("message.common.option") }}
                </td>
                <td>
                  <v-list>
                    <v-list-item v-for="option in user.allowed_options" :key="option" class="pl-0" dense>
                      <template v-if="['develop', 'in-company'].indexOf(option) >= 0">
                        <template v-if="$store.getters.enable_options.indexOf(option) >= 0">
                          {{ $t('message.common.option_' + option) }}&nbsp;
                          ({{ $t('message.profile.enable') }})
                        </template>
                        <template v-else>
                          <span class="text--secondary">
                            {{ $t('message.common.option_' + option) }}&nbsp;
                            ({{ $t('message.profile.disable') }})
                          </span>
                        </template>
                      </template>
                      <template v-else>
                        {{ $t('message.common.option_' + option) }}
                      </template>
                    </v-list-item>
                  </v-list>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <p class="text-right">
        <v-btn to="/">
          {{ $t("message.common.prev") }}
        </v-btn>
      </p>
    </v-card>
    <v-card class="pa-5 mt-1" v-else>
      {{ $t("message.profile.no_profile") }}
      <p class="text-right">
        <v-btn to="/">
          {{ $t("message.common.prev") }}
        </v-btn>
      </p>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '../components/Breadcrumbs'
import IdName from '../components/IdName'

export default {
  name: 'profile',
  components: {
    Breadcrumbs,
    IdName
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  data: function(){
    return {
      module_id: "05",
      nav_path: null
    }
  }
}
</script>

<style scoped>
.v-data-table
  tbody
  tr:hover:not(.v-data-table__expanded__content) {
  background: inherit !important;
}
.v-data-table td:first-of-type {
  white-space : nowrap;
}
</style>
